import { useState } from 'react';
import { BarChart3, Target, TrendingUp, Calendar } from 'lucide-react';
import { BudgetForecastTab } from './BudgetForecastTab';
import { TrackingTab } from './TrackingTab';
import { ScenariosTab } from './ScenariosTab';
import ForecastListPage from '../pages/ForecastListPage';

type SubTab = 'forecast' | 'tracking' | 'scenarios' | 'forecast5y';

export function BudgetTab() {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('forecast');

  const subTabs = [
    { id: 'forecast' as SubTab, label: 'Budget prévisionnel', icon: BarChart3 },
    { id: 'tracking' as SubTab, label: 'Suivi budgétaire', icon: Target },
    { id: 'scenarios' as SubTab, label: 'Scénarios', icon: TrendingUp },
    { id: 'forecast5y' as SubTab, label: 'Prévisionnel 5 ans', icon: Calendar }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
        <div className="flex gap-2 border-b border-gray-200">
          {subTabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2.5 font-medium transition-all relative ${
                  activeSubTab === tab.id
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <Icon size={18} />
                {tab.label}
                {activeSubTab === tab.id && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-t" />
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="transition-opacity duration-200">
        {activeSubTab === 'forecast' && <BudgetForecastTab />}
        {activeSubTab === 'tracking' && <TrackingTab />}
        {activeSubTab === 'scenarios' && <ScenariosTab />}
        {activeSubTab === 'forecast5y' && <ForecastListPage />}
      </div>
    </div>
  );
}
